const locale = {
  DUPLICATE_OF: 'Duplicaat van',
  DUPLICATED_BY: 'Gedupliceerd door',
  RELATED_TO: 'Gerelateerd aan',
  SPLIT_TO: 'Gesplitst naar',
  SPLIT_FROM: 'Gesplitst van',
  BLOCKED_BY: 'Geblokkeerd door',
  BLOCKS: 'Blokkeert',
  MORE_THAN: 'Groter dan',
  LESS_THAN: 'Kleiner dan',
  OPEN: 'Open',
  IN_PROGRESS: 'Bezig',
  ON_HOLD: 'In wacht',
  COMPLETE: 'Voltooid',
  'home.built': 'Ontworpen om onderhoud eenvoudiger te beheren',
  home_description:
    'Wanneer whiteboards en plakbriefjes chaos veroorzaken, en je een CMMS-software nodig hebt die eenvoudig genoeg is voor je team om daadwerkelijk te gebruiken - probeer Atlas',
  try_grash: 'Probeer Atlas',
  login: 'Inloggen',
  start_trial: 'Start een gratis proefperiode',
  'home.what': 'Wat',
  'home.you_will_have': 'Je krijgt',
  'home.you_will_have_description':
    'Bouw efficiënte, betrouwbare workflows die jou de controle geven over onderhoud. Genereer, wijs toe en volg werkorders. Beheer voorraad. En ontvang betrouwbare geautomatiseerde rapporten die de zichtbaarheid verbeteren en verantwoordelijkheid creëren.',
  key_features: 'Belangrijkste functies',
  key_features_description:
    'Enkele van de functies die Atlas tot een van de beste CMMS van vandaag maken',
  contribute: 'Bijdragen',
  work_orders: 'Werkorders',
  request_system: 'Werkverzoekensysteem',
  mobile_app: 'Mobiele app',
  asset_management: 'Assetbeheer',
  preventive_maintenance: 'Preventief onderhoud',
  parts_inventory: 'Onderdelenvoorraad',
  custom_dashboards: 'Aangepaste dashboards',
  'work-orders.title': 'Beheer je werkorders als een baas',
  'work-orders.description.short': 'Bekijk en beheer al je taken',
  'work-orders.descriptions.0':
    'Genoeg van stapels papierwerk en verloren werkorders? Al die verloren items beïnvloeden direct de winst en je reputatie.',
  'work-orders.descriptions.1':
    'Met Atlas kun je eenvoudig en snel al je werkorders, preventief onderhoud en andere taken binnen je team organiseren in een gecentraliseerde database die overal en op elk apparaat toegankelijk is.',
  'work-orders.checks.0':
    'Bekijk al je taken inclusief werkorders, preventief onderhoud en werkverzoeken',
  'work-orders.checks.1':
    'Stel taakprioriteit in zodat het juiste werk als eerste wordt gedaan.',
  'work-orders.checks.2':
    'Bekijk een kalender van huidige en aankomende taken.',
  'work-orders.checks.3':
    'Bekijk werktoewijzingen met cruciale informatie zoals assetinformatie, vervaldatum, prioriteit en meer.',
  'work-orders.checks.4':
    "Bekijk kritieke KPI's zoals daadwerkelijk voltooid werk, bestede tijd en gepland versus ongepland werk.",
  'work-requests.title': 'Een gestroomlijnd mobiel werkverzoekensysteem',
  'work-requests.descriptions.0':
    'Genoeg van het oude telefoon- en emailsysteem dat leidt tot VERLOREN tickets, constante dagelijkse onderbrekingen en dubbel werk?',
  'work-requests.descriptions.1':
    'De onderhoudsbeheersoplossing van Atlas stelt iedereen die je autoriseert in staat een probleem in te dienen bij je onderhoudsafdeling door simpelweg een QR-code (streepjescode) te scannen of een URL te bezoeken en hun verzoek via hun mobiele apparaten in te typen.',
  'work-requests.checks.0': 'Verlies nooit meer werk.',
  'work-requests.checks.1':
    'Verminder de tijd besteed aan het afhandelen van werkverzoeken met tot wel 34%.',
  'work-requests.checks.2':
    "Verminder de communicatie met verzoekers met tot wel 41% (oproepen, e-mails, sms'en).",
  'mobile-app.title': 'Een mobiele CMMS-app die je onderhoudsteam versterkt',
  'mobile-app.descriptions.0':
    'Door het gebruik van onze Android- en iOS-mobiele apps ervaren onze klanten betere organisatie, communicatie, verantwoordelijkheid en productiviteit tot wel 30% binnen hun gehele onderhoudsteam.',
  'mobile-app.descriptions.1':
    'Vanaf hun handheld apparaat kan iedereen in je onderhoudsteam:',
  'mobile-app.checks.0':
    'Hun toegewezen werkorders en preventief onderhoud bekijken.',
  'mobile-app.checks.1': 'Hun werkorders binnen 60 seconden registreren',
  'mobile-app.checks.2':
    'Directe communicatie ontvangen via push- en e-mailmeldingen.',
  'mobile-app.checks.3':
    'Nieuwe werkorders starten terwijl ze in het veld zijn.',
  'mobile-app.checks.4':
    'Reageren op en problemen registreren terwijl ze daadwerkelijk aan het probleem werken',
  'mobile-app.checks.5':
    'Kritieke assetinformatie opzoeken tijdens het diagnosticeren van een probleem.',
  'eam.title': 'Enterprise Asset Management',
  'eam.description.short': 'Ken je assets',
  'eam.descriptions.0':
    'Gefrustreerd door het proberen te organiseren van de chaotische rommel van de apparatuur van het bedrijf, je afvragend of de apparatuur goed is onderhouden, niet wetend wat de onderhoudskosten zijn en alle andere hoofdpijn die komt kijken bij assetbeheer?',
  'eam.descriptions.1':
    'De Enterprise Asset Management-module van Atlas CMMS kan worden gebruikt voor tussen de 10 en 1.000.000 Assets, waardoor u precies kunt bijhouden wat u wilt, op de manier die u wilt, in een gebruiksvriendelijke en doorzoekbare boomstructuur.',
  'eam.checks.0':
    'Ken de status van uw assets op elk moment en wat ze u kosten',
  'eam.checks.1': 'Bekijk volledige en gedetailleerde onderhoudslogboeken.',
  'eam.checks.2': 'Volg alleen wat u wilt met onbeperkte aangepaste velden',
  'eam.checks.3':
    'Organiseer uw assets in een duidelijke ouder-kind hiërarchie',
  'eam.checks.4':
    'Vind informatie snel en eenvoudig met QR-codes (streepjescodes)',
  'eam.checks.5': 'Ontvang realtime assetgegevens met sensorconnectiviteit.',

  'pm.title': 'Een effectief preventief onderhoudsprogramma',
  'pm.descriptions.0':
    'Stop met het verspillen van kostbare uren aan het handmatig verspreiden van PM-checklists en het opvolgen bij uw team om ervoor te zorgen dat het werk wordt gedaan.',
  'pm.descriptions.1':
    'Atlas stelt u in staat om PM-planning eenvoudig te automatiseren, zodat het juiste werk automatisch op het juiste moment aan de juiste technicus voor de juiste Asset wordt geleverd.',
  'pm.checks.0':
    'Automatiseer PM-planning op dagelijkse, wekelijkse, maandelijkse, jaarlijkse basis of op basis van gebeurtenissen of meterstanden.',
  'pm.checks.1':
    'Automatische push- en e-mailmeldingen wanneer een PM wordt aangemaakt of moet worden uitgevoerd.',
  'pm.checks.2':
    "Onze gebruiksvriendelijke kalender stelt u in staat om al het openstaande werk en aankomende PM-schema's te bekijken.",
  'pm.checks.3': 'Sleep en zet neer om de vervaldatum te wijzigen.',
  'pm.checks.4':
    'Na voltooiing van de PM wordt het werk automatisch geregistreerd in het onderhoudslogboek van de asset.',
  'pm.checks.5': 'Vereist weinig tot geen training om te gebruiken.',

  'part.title': 'Krijg controle over uw reserveonderdelenvoorraad',
  'part.description.short': 'Weet wanneer uw onderdelen opraken',
  'part.descriptions.0':
    'Weet u niet welke onderdelen u op voorraad heeft of waar ze worden gebruikt? Weet u niet wanneer uw onderdelen opraken of of uw technici de benodigde onderdelen hebben om hun werk te doen?',
  'part.descriptions.1':
    'We hebben het onderdelenbeheer van Atlas ontworpen om die problemen en meer op te lossen:',
  'part.checks.0':
    'Ontvang direct push- en e-mailmeldingen wanneer de hoeveelheid van een onderdeel laag is. Houd het juiste aantal onderdelen op voorraad door direct en automatisch push-/e-mailmeldingen te ontvangen wanneer de hoeveelheid van een onderdeel onder een aangepaste drempelwaarde komt.',
  'part.checks.1':
    'Technici weten direct of het onderdeel op voorraad is vanuit een werkorder. Als het onderdeel niet op voorraad is, kunt u eenvoudig andere locaties controleren om te zien of het beschikbaar is.',
  'part.checks.2':
    "Automatische registratie van onderdelengebruik. Naarmate werkorders of PM's onderdelen gebruiken, wordt de voorraad automatisch bijgewerkt om het gebruikte aantal weer te geven.",
  'part.checks.3':
    'Ken het gebruik van onderdelen. Bekijk het onderdelenlogboek om te zien waar het onderdeel wordt gebruikt en door wie',
  'part.checks.4':
    'Elimineer ongebruikte onderdelen. Weet wanneer een onderdeel verouderd is.',
  'part.checks.5':
    'Realtime rapportage. Weet welke onderdelen waar worden gebruikt en wat ze u kosten.',
  'part.checks.6':
    'Optimaliseer voorraadniveaus. Bekijk direct de prognose voor een onderdeel om te zien hoeveel onderdelen er binnen het komende jaar kunnen worden gebruikt.',
  'part.checks.7':
    'Barcode-zoekfunctie. Maak uw voorraad gemakkelijk te volgen en toegankelijk met aangepaste QR-codes',

  'dashboard.title': 'Uw data, uw manier met aangepaste dashboards',
  'dashboard.descriptions.0':
    'Laten we eerlijk zijn, de eerste stap om uw operaties te verbeteren is het kennen van het goede, het slechte en het lelijke.',
  'dashboard.descriptions.1':
    'Met de aangepaste dashboards van Atlas kunt u eindelijk dat duistere “zwarte gat van onderhoud” begrijpen en beginnen met het uitvoeren van op data gebaseerde plannen, wat resulteert in lagere arbeidskosten, minder stilstand en meer.',
  'dashboard.descriptions.2': 'Met de aangepaste dashboards van Atlas kunt u …',
  'dashboard.checks.0': 'Weten waar uw geld aan wordt uitgegeven en waarom',
  'dashboard.checks.1': 'Weten welk asset het meeste kost en waarom',
  'dashboard.checks.2': "Maak uw eigen aangepaste KPI's.",
  'dashboard.checks.3':
    'Bekijk rapporten die automatisch worden gegenereerd en bijgewerkt op basis van uw metriek',
  'dashboard.checks.4':
    "Bekijk rapporten die gemakkelijk gedeeld kunnen worden via Excel-bestanden, PDF's of binnen Atlas",
  'dashboard.checks.5': 'En nog veel meer ...',
  'home.smarter': 'Slimmer',
  'home.work': 'Werk',
  'home.smarter_description':
    'Atlas maakt het technici ongelooflijk gemakkelijk om efficiënt te werken door hen toegang te geven tot de tools en gegevens die ze nodig hebben om het werk gedaan te krijgen — allemaal vanuit de palm van hun hand.',
  leading_maintenance:
    'De weg wijzen naar een betere toekomst voor onderhoud en betrouwbaarheid',
  //register
  premium_included: 'Premium functies inbegrepen',
  no_credit_card: 'Geen creditcard vereist',
  perfect_tool: 'Het perfecte hulpmiddel voor onderhoudsteams',
  start_trial_today: 'Start vandaag nog uw gratis proefperiode',
  create_account: 'Account aanmaken',
  signup_description:
    'Vul de onderstaande velden in om u aan te melden voor een account.',
  account_already: 'Heeft u al een account?',
  signin_here: 'Log hier in',
  invalid_email: 'Het opgegeven e-mailadres moet een geldig e-mailadres zijn',
  required_email: 'Het e-mailveld is verplicht',
  required_firstName: 'Het veld voornaam is verplicht',
  required_lastName: 'Het veld achternaam is verplicht',
  required_company: 'Het veld bedrijfsnaam is verplicht',
  required_employeesCount: 'Geef het aantal werknemers op',
  invalid_phone: 'Het telefoonnummer is ongeldig',
  required_password: 'Het veld wachtwoord is verplicht',
  required_terms: 'U moet akkoord gaan met onze algemene voorwaarden',
  verify_email: 'Controleer uw e-mail om uw account te activeren',
  registration_error: 'De registratie is niet gelukt',
  first_name: 'Voornaam',
  last_name: 'Achternaam',
  email: 'E-mailadres',
  phone: 'Telefoon',
  password: 'Wachtwoord',
  companyName: 'Bedrijfsnaam',
  employeesCount: 'Aantal werknemers',
  i_accept: 'Ik ga akkoord met de',
  terms_conditions: 'algemene voorwaarden',
  required_fields_notice: 'Alle velden gemarkeerd met * zijn verplicht.',
  create_your_account: 'Maak uw account aan',
  register: 'Registreren',
  //signin
  login_description:
    'Vul onderstaande velden in om in te loggen op uw account.',
  no_account_yet: 'Heeft u nog geen account?',
  signup_here: 'Registreer hier',
  wrong_credentials: 'Onjuiste inloggegevens opgegeven',
  lost_password: 'Wachtwoord vergeten?',
  //work-orders
  link_wo: 'Werkorders koppelen',
  link_wo_description: 'Maak relaties tussen werkorders',
  required_relationType: 'Selecteer het type relatie.',
  required_wo: 'Het veld werkorder is verplicht.',
  this_wo: 'Deze werkorder',
  the_wo: 'De werkorder',
  link: 'Koppelen',
  cost_description: 'Kostenbeschrijving',
  assigned_to: 'Toegewezen aan',
  category: 'Categorie',
  date: 'Datum',
  cost: 'Kosten',
  include_cost: 'Neem deze kosten op in de totale kosten',
  include_cost_description:
    'Dit voegt de kosten toe aan de totale kosten van de werkorder',
  required_cost_description: 'Kostenbeschrijving is verplicht',
  required_cost: 'Kosten zijn verplicht',
  add_cost: 'Extra kosten toevoegen',
  add_cost_description:
    'Vul onderstaande velden in om extra kosten aan te maken en toe te voegen',
  add: 'Toevoegen',
  hourly_rate: 'Uurtarief',
  include_time: 'Neem deze tijd op in de totale tijd',
  include_time_description:
    'Dit voegt de duur toe aan de totale tijd besteed aan de werkorder',
  work_started_at: 'Werk gestart om',
  duration: 'Duur',
  hours: 'Uren',
  minutes: 'Minuten',
  required_hours: 'Het veld uren is verplicht',
  required_minutes: 'Het veld minuten is verplicht',
  add_time: 'Tijd toevoegen',
  add_time_description:
    'Vul onderstaande velden in om tijd aan te maken en toe te voegen',
  feedback: 'Feedback',
  feedback_description: 'Geef uw feedback',
  required_feedback: 'Feedback is verplicht',
  signature: 'Handtekening',
  required_signature: 'Handtekening is verplicht',
  close_wo: 'Werkorder sluiten',
  close: 'Sluiten',
  task_update_success: 'Taak succesvol bijgewerkt',
  task_update_failure: 'Taak kon niet worden bijgewerkt',
  notes_save_success: 'Notities succesvol opgeslagen',
  images_add_task_success: 'De afbeeldingen zijn toegevoegd aan de taak',
  images_add_task_failure: 'Er is iets misgegaan',
  images: 'Afbeeldingen',
  required_images: 'Upload minimaal één afbeelding',
  add_images: 'Afbeeldingen toevoegen',
  tasks: 'Taken',
  wo_archive_success: 'De werkorder is gearchiveerd',
  wo_archive_failure: 'De werkorder kon niet worden gearchiveerd',
  wo_archive_confirm: 'Weet u zeker dat u deze werkorder wilt archiveren ',
  quantity_change_success: 'Aantal succesvol gewijzigd',
  quantity_change_failure: 'Aantal kon niet worden gewijzigd',
  details: 'Details',
  updates: 'Updates',
  id: 'ID',
  due_date: 'Vervaldatum',
  location: 'Locatie',
  asset: 'Asset',
  team: 'Team',
  created_at: 'Datum aangemaakt',
  list_view: 'Lijstweergave',
  calendar_view: 'Kalenderweergave',
  column_view: 'Kolomweergave',
  wo_create_success: 'De werkorder is succesvol aangemaakt',
  wo_create_failure: 'De werkorder kon niet worden aangemaakt',
  changes_saved_success: 'De wijzigingen zijn opgeslagen',
  wo_update_failure: 'De werkorder kon niet worden bewerkt',
  wo_delete_success: 'De werkorder is succesvol verwijderd',
  wo_delete_failure: 'De werkorder kon niet worden verwijderd',
  status: 'Status',
  title: 'Titel',
  priority: 'Prioriteit',
  description: 'Beschrijving',
  worker: 'Medewerker',
  location_name: 'Locatienaam',
  location_address: 'Locatieadres',
  asset_name: 'Assetnaam',
  days_since_creation: 'Dagen sinds aanmaak',
  files: 'Bestanden',
  requested_by: 'Aangevraagd door',
  completed_on: 'Voltooid op',
  updated_at: 'Bijgewerkt op',
  work_order: 'Werkorder',
  timer_running: 'Timer loopt',
  run_timer: 'Start timer',
  approved_by: 'Goedgekeurd door',
  created_by: 'Aangemaakt door',
  completed_by: 'Voltooid door',
  time: 'Tijd',
  save: 'Opslaan',
  customers: 'Aannemers',
  no_labor:
    'Er zijn nog geen arbeidskosten toegevoegd. Deze verschijnen hier zodra een gebruiker tijd registreert en een uurtarief in Atlas heeft opgeslagen.',
  not_assigned: 'Niet toegewezen',
  no_additional_cost: 'Er zijn nog geen extra kosten toegevoegd',
  parts: 'Onderdelen',
  links: 'Links',
  confirm_delete_file_wo:
    'Weet u zeker dat u dit bestand van deze werkorder wilt verwijderen?',
  archive: 'Archief',
  labors: 'Arbeidsuren',
  add_additional_cost: 'Voeg extra kosten toe',
  additional_costs: 'Extra kosten',
  add_parts: 'Voeg onderdelen toe',
  'wo.title_description': 'Voer de titel van de werkorder in',
  image: 'Afbeelding',
  estimated_duration: 'Geschatte duur in uren',
  primary_worker: 'Hoofdmedewerker',
  additional_workers: 'Extra medewerkers',
  select_team: 'Selecteer team',
  select_location: 'Selecteer locatie',
  select_asset: 'Selecteer asset',
  select_tasks: 'Selecteer taken',
  requires_signature: 'Handtekening vereist',
  required_wo_title: 'Werkordertitel is verplicht',
  add_wo: 'Werkorder toevoegen',
  add_wo_description:
    'Vul onderstaande velden in om een nieuwe werkorder aan te maken en toe te voegen',
  edit_wo: 'Werkorder bewerken',
  edit_wo_description:
    'Vul onderstaande velden in om de werkorder bij te werken',
  'noRows.wo.message':
    'Werkorders zijn taken of opdrachten die gepland of toegewezen kunnen worden aan iemand',
  'noRows.wo.action': "Druk op de '+' knop om een werkorder aan te maken",
  to_delete: 'Verwijderen',
  confirm_delete_wo: 'Weet u zeker dat u deze werkorder wilt verwijderen?',
  no_access_wo:
    'U heeft geen toegang tot werkorders. Neem contact op met uw beheerder als u toegang zou moeten hebben',
  cancel: 'Annuleren',
  select_parts: 'Selecteer onderdelen',
  sets_of_parts: 'Sets onderdelen',
  paused: 'Gepauzeerd',
  trigger_details: 'Triggerdetails',
  starts_on: 'Start op',
  ends_on: 'Eindigt op',
  frequency: 'Frequentie',
  every_frequency_days: 'Elke {{frequency}} dagen',
  wo_details: 'Werkorderdetails',
  confirm_delete_file: 'Weet u zeker dat u dit bestand wilt verwijderen?',
  wo_schedule_success: 'Werkorder succesvol ingepland',
  wo_schedule_failure: 'De werkorder kon niet worden ingepland',
  wo_trigger_edit_failure: 'De werkordertrigger kon niet worden bewerkt',
  wo_trigger_delete_success: 'De werkordertrigger is succesvol verwijderd',
  wo_trigger_delete_failure: 'De werkordertrigger kon niet worden verwijderd',
  name: 'Naam',
  wo_title: 'Werkordertitel',
  next_wo: 'Volgende werkorder',
  trigger_name: 'Triggernaam',
  enter_trigger_name: 'Voer triggernaam in',
  frequency_description: 'Frequentie in dagen',
  wo_configuration: 'Werkorderconfiguratie',
  required_trigger_name: 'Triggernaam is verplicht',
  required_frequency: 'De triggerfrequentie is verplicht',
  invalid_frequency: 'Frequentie moet groter zijn dan 0',
  schedule_wo: 'Werkorder plannen',
  schedule_wo_description:
    'Vul onderstaande velden in om een werkorder te plannen',
  edit_wo_trigger: 'Werkordertrigger bewerken',
  edit_wo_trigger_description:
    'Vul onderstaande velden in om de werkordertrigger te bewerken',
  create_trigger: 'Trigger aanmaken',
  'noRows.pm.message': 'Plan werkorders met aangepaste triggers',
  'noRows.pm.action': "Druk op de '+' knop om een trigger aan te maken",
  confirm_delete_pm:
    'Weet u zeker dat u deze werkordertrigger wilt verwijderen?',
  no_access_pm:
    'U heeft geen toegang tot de Preventief Onderhoud sectie. Neem contact op met uw beheerder als u toegang zou moeten hebben',
  enter_wo_title: 'Voer werkordertitel in',
  status_report: 'Statusrapport',
  wo_analysis: 'Werkorderanalyse',
  wo_aging: 'Werkorderveroudering',
  time_and_cost: 'Tijd en kosten',
  assets: 'Assets',
  reliability_dashboard: 'Betrouwbaarheidsdashboard',
  total_maintenance_cost: 'Totale onderhoudskosten',
  useful_life: 'Levensduur',
  requests: 'Verzoeken',
  locations: 'Locaties',
  parts_and_inventory: 'Onderdelen/Voorraad',
  purchase_orders: 'Inkooporders',
  meters: 'Meters',
  people_teams: 'Personen & Teams',
  people: 'Personen',
  teams: 'Teams',
  vendors_customers: 'Leveranciers & Aannemers',
  vendors: 'Leveranciers',
  categories: 'Categorieën',
  settings: 'Instellingen',
  cancelled: 'Geannuleerd',
  reject: 'Afwijzen',
  approve: 'Goedkeuren',
  request_create_success: 'Werkorder succesvol aangevraagd',
  request_create_failure: 'De werkverzoek kon niet worden aangemaakt',
  request_edit_failure: 'Het verzoek kon niet worden bewerkt',
  request_delete_success: 'Het verzoek is succesvol verwijderd',
  request_delete_failure: 'Het verzoek kon niet worden verwijderd',
  rejected: 'Afgewezen',
  approved: 'Goedgekeurd',
  pending: 'In afwachting',
  required_request_name: 'Verzoektitel is verplicht',
  required_field: 'Dit veld is verplicht',
  add_request: 'Verzoek toevoegen',
  add_request_description:
    'Vul onderstaande velden in om een nieuw verzoek aan te maken en toe te voegen',
  edit_request: 'Verzoek bewerken',
  edit_request_description:
    'Vul onderstaande velden in om het verzoek te bewerken',
  'noRows.request.message': 'Beheer uw werkverzoeken',
  'noRows.request.action':
    "Druk op de '+' knop om een werkverzoek aan te maken",
  confirm_delete_request: 'Weet u zeker dat u dit verzoek wilt verwijderen?',
  request: 'Aanvraag',
  request_details: 'Aanvraagdetails',
  none_priority: 'Geen',
  low_priority: 'Laag',
  medium_priority: 'Middel',
  high_priority: 'Hoog',
  //asset
  downtimes: 'Stilstanden',
  confirm_delete_file_asset:
    'Weet u zeker dat u dit bestand van dit asset wilt verwijderen?',
  actions: 'Acties',
  show: 'Toon',
  model: 'Model',
  serial_number: 'Serienummer',
  operational: 'Operationeel',
  down: 'Uitgevallen',
  area: 'Gebied',
  barcode: 'Barcode',
  placed_in_service: 'In gebruik genomen',
  warranty_expiration: 'Garantie vervalt',
  asset_information: 'Assetinformatie',
  more_informations: 'Meer informatie',
  confirm_delete_asset_downtime:
    'Weet u zeker dat u deze stilstand wilt verwijderen?',
  create_downtime_success: 'De stilstand is succesvol toegevoegd',
  create_downtime_failure: 'De stilstand kon niet worden toegevoegd',
  edit_downtime_success: 'De stilstand is succesvol bewerkt',
  started_on: 'Gestart op',
  required_startsOn: 'De startdatum is verplicht',
  reading_create_success: 'De meting is succesvol toegevoegd',
  reading_create_failure: 'De meting kon niet worden toegevoegd',
  reading: 'Meting',
  added_by: 'Toegevoegd door',
  enter_meter_value: 'Voer meterwaarde in',
  add_reading: 'Meting toevoegen',
  select_meter: 'Selecteer meter',
  confirm_delete_part_asset:
    'Weet u zeker dat u dit onderdeel van dit asset wilt verwijderen?',
  no_due_date: 'Geen vervaldatum',
  due_at_date: 'Vervalt op {{date}}',
  no_primary_worker: 'Geen primaire medewerker',
  no_wo_linked_asset: 'Er is geen werkorder gekoppeld aan dit asset',
  asset_remove_success: 'Het asset is succesvol verwijderd',
  asset_remove_failure: 'Het asset kon niet worden verwijderd',
  asset_name_description: 'Voer assetnaam in',
  select_asset_location: 'Selecteer assetlocatie',
  primary_user_description: 'Selecteer primaire gebruiker',
  teams_description: 'Selecteer teams',
  customers_description: 'Selecteer aannemers',
  vendors_description: 'Selecteer leveranciers',
  inServiceDate_description: 'Datum in gebruik genomen',
  warranty_expiration_date: 'Datum garantie vervalt',
  additional_information: 'Aanvullende informatie',
  structure: 'Structuur',
  parent_asset: 'Hoofdasset',
  asset_create_success: 'Het asset is succesvol aangemaakt',
  asset_create_failure: 'Het asset kon niet worden aangemaakt',
  additional_workers_description: 'Selecteer aanvullende medewerkers',
  required_asset_name: 'Assetnaam is verplicht',
  add_asset: 'Asset toevoegen',
  add_asset_description:
    'Vul onderstaande velden in om een nieuw asset aan te maken en toe te voegen',
  create_asset: 'Asset aanmaken',
  hierarchy: 'Hiërarchie',
  add_downtime: 'Stilstand toevoegen',
  edit_downtime: 'Stilstand bewerken',
  remove_downtime: 'Stilstand verwijderen',
  edit: 'Bewerken',
  edit_asset: 'Asset bewerken',
  edit_asset_description: 'Vul onderstaande velden in om dit asset te bewerken',
  confirm_delete_asset: 'Weet u zeker dat u dit asset wilt verwijderen?',
  loading_assets: 'Assets laden onder {{name}} #{{id}}',
  no_content: 'Geen inhoud',
  no_result_criteria: 'Geen resultaten die aan uw zoekcriteria voldoen',
  //location
  map_view: 'Kaartweergave',
  location_create_success: 'De locatie is succesvol aangemaakt',
  location_create_failure: 'De locatie kon niet worden aangemaakt',
  location_edit_failure: 'De locatie kon niet worden bewerkt',
  location_delete_success: 'De locatie is succesvol verwijderd',
  location_delete_failure: 'De locatie kon niet worden verwijderd',
  enter_location_name: 'Voer locatie naam in',
  address: 'Adres',
  parent_location: 'Bovenliggende locatie',
  select_workers: 'Selecteer medewerkers',
  map_coordinates: 'Kaartcoördinaten',
  required_location_name: 'Locatienaam is verplicht',
  required_location_address: 'Locatieadres is verplicht',
  add_location: 'Locatie toevoegen',
  add_location_description:
    'Vul onderstaande velden in om een nieuwe locatie aan te maken en toe te voegen',
  edit_location: 'Locatie bewerken',
  edit_location_description:
    'Vul onderstaande velden in om de locatie bij te werken',
  confirm_delete_location: 'Weet u zeker dat u deze locatie wilt verwijderen?',
  floor_plans: 'Plattegronden',
  floor_plan: 'Plattegrond',
  floor_plan_name_description: 'Naam plattegrond',
  'Floor plan area in m²': 'Oppervlakte plattegrond in m²',
  upload_image: 'Upload een afbeelding',
  required_floor_plan_name: 'Naam plattegrond is verplicht',
  add_floor_plan: 'Nieuwe plattegrond toevoegen',
  add_floor_plan_description:
    'Vul onderstaande velden in om een nieuwe plattegrond aan te maken',
  no_asset_in_location: 'Geen asset op deze locatie',
  no_wo_in_location: 'Geen werkorder op deze locatie',
  no_file_in_location: 'Geen bestanden gekoppeld aan deze locatie',
  no_floor_plan_in_location: 'Geen plattegrond op deze locatie',
  assigned_teams: 'Toegewezen teams',
  assigned_customers: 'Toegewezen aannemers',
  assigned_vendors: 'Toegewezen leveranciers',
  no_access_location:
    'U heeft geen toegang tot locaties. Neem contact op met uw beheerder als u toegang zou moeten hebben',
  no_access_vendors_customers:
    'U heeft geen toegang tot leveranciers en aannemers. Neem contact op met uw beheerder als u toegang zou moeten hebben',
  no_access_people_team:
    'U heeft geen toegang tot personen en teams. Neem contact op met uw beheerder als u toegang zou moeten hebben',
  no_access_analytics:
    'U heeft geen toegang tot analytics. Neem contact op met uw beheerder als u toegang zou moeten hebben',
  no_access_assets:
    'U heeft geen toegang tot assets. Neem contact op met uw beheerder als u toegang zou moeten hebben',
  no_access_categories:
    'U heeft geen toegang tot categorieën. Neem contact op met uw beheerder als u toegang zou moeten hebben',
  no_access_files:
    'U heeft geen toegang tot bestanden. Neem contact op met uw beheerder als u toegang zou moeten hebben',
  no_access_inventory:
    'U heeft geen toegang tot de inventaris. Neem contact op met uw beheerder als u toegang zou moeten hebben',
  no_access_meters:
    'U heeft geen toegang tot meters. Neem contact op met uw beheerder als u toegang zou moeten hebben',
  no_access_purchase_orders:
    'U kunt geen inkooporder aanmaken. Neem contact op met uw beheerder als u toegang zou moeten hebben',
  no_access_requests:
    'U heeft geen toegang tot verzoeken. Neem contact op met uw beheerder als u toegang zou moeten hebben',
  no_access_settings:
    'U heeft geen toegang tot instellingen. Neem contact op met uw beheerder als u toegang zou moeten hebben',
  no_access_page: 'U heeft geen toegang tot deze pagina',
  file: 'Bestand',
  'noRows.location.message':
    'Locaties helpen u assets en medewerkers efficiënter te beheren',
  'noRows.location.action': "Druk op de '+' knop om een locatie aan te maken",
  card_view: 'Kaartweergave',
  set_create_success: 'De set is succesvol aangemaakt',
  set_create_failure: 'De set kon niet worden aangemaakt',
  set_edit_failure: 'De set kon niet worden bewerkt',
  set_delete_success: 'De set is succesvol verwijderd',
  set_delete_failure: 'De set kon niet worden verwijderd',
  total_cost: 'Totale kosten',
  part: 'Onderdeel',
  enter_part_name: 'Voer onderdeelnaam in',
  required_set_name: 'Setnaam is verplicht',
  add_set: 'Set toevoegen',
  add_set_description:
    'Vul onderstaande velden in om een nieuwe set aan te maken en toe te voegen',
  create_set: 'Set aanmaken',
  edit_set: 'Set bewerken',
  edit_set_description: 'Vul onderstaande velden in om de set te bewerken',
  confirm_delete_set: 'Weet u zeker dat u deze set wilt verwijderen?',
  part_create_success: 'Het onderdeel is succesvol aangemaakt',
  part_create_failure: 'Het onderdeel kon niet worden aangemaakt',
  part_edit_failure: 'Het onderdeel kon niet worden bewerkt',
  part_delete_success: 'Het onderdeel is succesvol verwijderd',
  part_delete_failure: 'Het onderdeel kon niet worden verwijderd',
  quantity: 'Aantal',
  open_wo: 'Openstaande werkorders',
  enter_part_category: 'Voer onderdeelcategorie in',
  enter_part_cost: 'Voer onderdeelkosten in',
  enter_part_quantity: 'Voer onderdeelhoeveelheid in',
  minimum_quantity: 'Minimale hoeveelheid',
  enter_part_minimum_quantity: 'Voer minimale onderdeelhoeveelheid in',
  non_stock: 'Niet op voorraad',
  enter_part_barcode: 'Voer onderdeelbarcode in',
  enter_part_area: 'Voer onderdeelgebied in',
  additional_part_details: 'Aanvullende onderdeelgegevens',
  add_part: 'Onderdeel toevoegen',
  add_part_description:
    'Vul onderstaande velden in om een nieuw onderdeel aan te maken en toe te voegen',
  create_part: 'Onderdeel aanmaken',
  update_part: 'Onderdeel bijwerken',
  update_part_description:
    'Vul onderstaande velden in om het onderdeel bij te werken',
  'noRows.part.message':
    'Onderdelen kunnen worden gecombineerd in assets of afzonderlijk worden gebruikt',
  'noRows.part.action': "Druk op de '+' knop om een onderdeel aan te maken",
  confirm_delete_part: 'Weet u zeker dat u dit onderdeel wilt verwijderen?',
  part_details: 'Onderdeelgegevens',
  area_details: 'Gebiedsgegevens',
  assigned_people: 'Toegewezen personen',
  no_asset_related_part: 'Geen asset gekoppeld aan dit onderdeel',
  no_file_found: 'Geen bestand gevonden',
  no_wo_found: 'Geen werkorder gevonden',
  workers: 'Medewerkers',
  Parts_and_Inventory: 'Onderdelen & Voorraad',
  //purchase order
  po_edit_failure: 'De inkooporder kon niet worden bewerkt',
  po_delete_success: 'De inkooporder is succesvol verwijderd',
  po_delete_failure: 'De inkooporder kon niet worden verwijderd',
  number_of_items: 'Aantal artikelen',
  total_quantity: 'Totale hoeveelheid',
  shipping_to: 'Verzenden naar',
  shipping_address: 'Verzendadres',
  po_details: 'Inkoopordergegevens',
  enter_po_name: 'Voer naam van inkooporder in',
  additional_details: 'Aanvullende details',
  vendor: 'Leverancier',
  shipping_information: 'Verzendinformatie',
  company_name: 'Bedrijfsnaam',
  ship_to: 'Verzenden naar',
  city: 'Plaats',
  state: 'Provincie',
  zip_code: 'Postcode',
  fax_number: 'Faxnummer',
  po_date: 'Datum inkooporder',
  notes: 'Notities',
  add_notes: 'Notities toevoegen',
  requisitioner: 'Aanvrager',
  terms: 'Voorwaarden',
  shipping_method: 'Verzendmethode',
  required_name: 'De naam is verplicht',
  edit_po: 'Inkooporder bewerken',
  edit_po_description:
    'Vul onderstaande velden in om de inkooporder bij te werken',
  purchase_order: 'Inkooporder',
  'noRows.po.message': 'Beheer uw inkooporders op één plek',
  'noRows.po.action': "Druk op de '+' knop om een inkooporder aan te maken.",
  confirm_delete_po: 'Weet u zeker dat u deze inkooporder wilt verwijderen?',
  upgrade_po: 'Upgrade om inkooporders aan te maken',
  new_po: 'Nieuwe inkooporder',
  po_create_success: 'De inkooporder is succesvol aangemaakt',
  select_one_part: 'Selecteer minimaal 1 onderdeel ',
  po_create_failure: 'De inkooporder kon niet worden aangemaakt',
  approve_while_submitting: 'Goedkeuren tijdens indienen',
  invalid_fax: 'Het faxnummer is ongeldig',
  submit: 'Indienen',
  each_item_superior_zero:
    'De hoeveelheid van elk artikel moet groter zijn dan 0',
  quantity_edit_success: 'Hoeveelheid succesvol gewijzigd',
  quantity_edit_failure: 'Hoeveelheid kon niet worden gewijzigd',
  APPROVED: 'Goedgekeurd',
  PENDING: 'In afwachting',
  REJECTED: 'Afgewezen',
  //meter
  when_reading_is: 'Wanneer meterstand is',
  greater_than: 'Groter dan',
  lower_than: 'Kleiner dan',
  value: 'Waarde',
  required_value: 'De waarde is verplicht',
  required_trigger_condition: 'De voorwaarde is verplicht',
  wo_trigger_create_success: 'De werkorder-trigger is succesvol aangemaakt',
  wo_trigger_create_failure: 'De werkorder-trigger kon niet worden aangemaakt',
  add_wo_trigger: 'Werkorder-trigger toevoegen',
  add_wo_trigger_description:
    'Vul onderstaande velden in om een werkorder-trigger aan te maken en toe te voegen',
  wo_trigger_edit_success: 'De werkorder-trigger is succesvol bijgewerkt',
  meter_create_success: 'De meter is succesvol aangemaakt',
  meter_create_failure: 'De meter kon niet worden aangemaakt',
  meter_edit_failure: 'De meter kon niet worden bewerkt',
  meter_delete_success: 'De meter is succesvol verwijderd',
  meter_delete_failure: 'De meter kon niet worden verwijderd',
  next_reading_due: 'Volgende aflezing verwacht',
  unit_of_measurement: 'Meeteenheid',
  last_reading: 'Laatste aflezing',
  enter_meter_name: 'Voer meternaam in',
  unit: 'Eenheid',
  update_frequency: 'Updatefrequentie',
  update_frequency_in_days: 'Updatefrequentie in dagen',
  required_meter_name: 'Meternaam is verplicht',
  required_meter_unit: 'Metereenheid is verplicht',
  required_meter_update_frequency: 'Updatefrequentie van de meter is verplicht',
  required_asset: 'Asset is verplicht',
  add_meter: 'Meter toevoegen',
  add_meter_description:
    'Vul onderstaande velden in om een nieuwe meter aan te maken en toe te voegen',
  edit_meter: 'Meter bewerken',
  edit_meter_description: 'Vul onderstaande velden in om de meter te bewerken',
  confirm_delete_meter: 'Weet u zeker dat u deze meter wilt verwijderen?',
  upgrade_create_meter: 'Upgrade om meters aan te maken',
  history: 'Geschiedenis',
  reading_frequency: 'Aflezingsfrequentie',
  required_reading_value: 'Aflezingswaarde is verplicht',
  wo_triggers: 'Werkorder-triggers',
  add_trigger: 'Trigger toevoegen',
  meter_details: 'Meterdetails',
  'noRows.meter.message':
    'Meteraflezingen geven u de mogelijkheid om assets te monitoren en nieuwe werkorders te triggeren op basis van gedefinieerde voorwaarden',
  'noRows.meter.action': "Druk op de '+' knop om een meter aan te maken",
  meter: 'Meter',
  //upload
  drag_one_file: 'Sleep hier een uniek bestand naartoe',
  drag_many_files: 'Sleep hier bestanden naartoe',
  drop_to_start: 'Laat de bestanden los om te beginnen met uploaden',
  invalid_files_type: 'U kunt deze bestandstypen niet uploaden',
  you_have_uploaded: 'U heeft geüpload',
  upload: 'Uploaden',
  //vendors_customers
  Vendors_Customers: 'Leveranciers & Aannemers',
  customer_create_success: 'De aannemer is succesvol aangemaakt',
  customer_create_failure: 'De aannemer kon niet worden aangemaakt',
  customer_edit_failure: 'De aannemer kon niet worden bewerkt',
  customer_delete_success: 'De aannemer is succesvol verwijderd',
  customer_delete_failure: 'De aannemer kon niet worden verwijderd',
  customer_name: 'Naam aannemer',
  website: 'Website',
  customer_type: 'Type aannemer',
  customer_type_description: 'bijv. Loodgieter, Elektricien',
  customer_description_description:
    'Beschrijf het doel van deze aannemer in een paar regels...',
  billing_information: 'Facturatiegegevens',
  address_line_2: 'Adresregel 2',
  billing_name: 'Facturatienaam',
  currency: 'Valuta',
  select_currency: 'Selecteer valuta',
  required_customer_name: 'Naam aannemer is verplicht',
  required_phone: 'Telefoonnummer is verplicht',
  invalid_website: 'Ongeldige website',
  billing_address: 'Factuuradres',
  add_customer: 'Aannemer toevoegen',
  add_customer_description:
    'Vul onderstaande velden in om een nieuwe aannemer aan te maken en toe te voegen',
  'noRows.customer.message': 'Aannemers zijn externe medewerkers',
  'noRows.customer.action': "Druk op de '+' knop om een aannemer aan te maken",
  type: 'Type',
  billing_currency: 'Facturatievaluta',
  go_back: 'Ga terug',
  confirm_delete_customer: 'Weet u zeker dat u deze Aannemer wilt verwijderen?',
  //vendor
  vendor_create_success: 'De Leverancier is succesvol aangemaakt',
  vendor_create_failure: 'De Leverancier kon niet worden aangemaakt',
  vendor_edit_failure: 'De Leverancier kon niet worden bewerkt',
  vendor_delete_success: 'De Leverancier is succesvol verwijderd',
  vendor_delete_failure: 'De Leverancier kon niet worden verwijderd',
  required_company_name: 'Bedrijfsnaam is verplicht',
  vendor_type: 'Type Leverancier',
  contact_name: 'Contactnaam',
  add_vendor: 'Leverancier toevoegen',
  add_vendor_description:
    'Vul onderstaande velden in om een nieuwe leverancier aan te maken en toe te voegen',
  confirm_delete_vendor:
    'Weet u zeker dat u deze Leverancier wilt verwijderen?',
  'noRows.vendor.message':
    'Leveranciers zijn organisaties die Assets of Onderdelen leveren',
  'noRows.vendor.action': "Druk op de '+' knop om een Leverancier aan te maken",
  vendor_type_description: 'bijv. Loodgieterij, Elektrotechniek',
  //people teams
  role: 'Rol',
  edit_user: 'Gebruiker bewerken',
  edit_user_description:
    'Vul onderstaande velden in om de gebruiker te bewerken',
  job_title: 'Functietitel',
  invite_users: 'Gebruikers uitnodigen',
  bring_people_team: 'Breng nieuwe mensen in het team',
  add_20_users:
    "U kunt 20 gebruikers tegelijk toevoegen door na elke e-mailinvoer op 'tab' of 'enter' te drukken. Dubbele en geregistreerde e-mails worden verwijderd tijdens het registreren van de gevraagde gebruikers.",
  enter_email: 'Voer e-mailadres in',
  users_invite_success: 'Gebruikers zijn uitgenodigd',
  users_invite_failure:
    'Gebruikers kunnen niet worden uitgenodigd. Controleer het aantal leden van uw huidige abonnement',
  please_type_emails: 'Typ alstublieft e-mails om uit te nodigen',
  please_select_role: 'Selecteer alstublieft een rol',
  invite: 'Uitnodigen',
  team_create_success: 'Het Team is succesvol aangemaakt',
  team_create_failure: 'Het Team kon niet worden aangemaakt',
  team_edit_failure: 'Het Team kon niet worden bewerkt',
  team_delete_success: 'Het Team is succesvol verwijderd',
  team_delete_failure: 'Het Team kon niet worden verwijderd',
  team_name: 'Teamnaam',
  people_in_team: 'Mensen in het team',
  required_team_name: 'Teamnaam is verplicht',
  create_team: 'Team aanmaken',
  create_team_description: 'U kunt hier teamleden toevoegen',
  confirm_delete_team: 'Weet u zeker dat u dit Team wilt verwijderen?',
  overview: 'Overzicht',
  activity: 'Activiteit',
  wo_complete_last_14_days: 'Werkorders voltooid in de laatste 14 dagen',
  no_wo_complete_last_14_days:
    'U heeft in de afgelopen twee weken geen werkorders voltooid',
  ADMIN_name: 'Beheerder',
  ADMIN_description:
    'Beheerders hebben volledige toegang; inclusief het bewerken, toevoegen, verwijderen van werkorders en verzoeken',
  LIMITED_ADMIN_name: 'Beperkte Beheerder',
  LIMITED_ADMIN_description:
    'Beperkte beheerders hebben dezelfde toegang als beheerders, behalve dat zij geen instellingen kunnen bekijken/bewerken of mensen en teams kunnen toevoegen/bewerken. Ze kunnen geen Werkorders, Assetlocaties, Meters en Inkooporders verwijderen tenzij zij Aannemers, Categorieën en PM-triggers hebben aangemaakt.',
  TECHNICIAN_name: 'Technicus',
  TECHNICIAN_description:
    'Technici kunnen werkorders, assets en locaties aanmaken en sluiten. Kunnen alleen bewerken en verwijderen wat zij zelf hebben aangemaakt',
  LIMITED_TECHNICIAN_name: 'Beperkte Technicus',
  LIMITED_TECHNICIAN_description:
    'Beperkte technici kunnen alleen werkorders zien die aan hen zijn toegewezen',
  VIEW_ONLY_name: 'Alleen Weergave',
  VIEW_ONLY_description:
    'Gebruikers met alleen-weergave hebben volledige kijkrechten, maar kunnen niets bewerken',
  REQUESTER_name: 'Aanvrager',
  REQUESTER_description:
    'Aanvragers kunnen alleen werkverzoeken indienen en de status daarvan bekijken',
  select_user_role: 'Selecteer gebruikersrol',
  'noRows.team.message': 'Teams helpen u specifieke groepen mensen te beheren.',
  'noRows.team.action': "Druk op de '+' knop om een team aan te maken.",
  user_details: 'Gebruikersgegevens',
  //files
  file_delete_success: 'Het bestand is succesvol verwijderd',
  file_delete_failure: 'Het bestand kon niet worden verwijderd',
  uploaded_by: 'Geüpload door',
  uploaded_on: 'Geüpload op',
  rename: 'Naam wijzigen',
  required_files: 'Upload minimaal één bestand',
  required_file_name: 'Voer een bestandsnaam in',
  add_files: 'Bestanden toevoegen',
  edit_file: 'Bestand bewerken',
  'noRows.file.message': 'Alle bestanden op één plek',
  'noRows.file.action': "Druk op de '+' knop om een bestand te uploaden",
  upgrade_files:
    'Upgrade om bestanden te gebruiken in uw Assets, Werkorders, Locaties enzovoort...',
  parts_consumption: 'Onderdelenverbruik',
  requests_analysis: 'Verzoekanalyse',
  category_create_success: 'De categorie is succesvol aangemaakt',
  category_create_failure: 'De categorie kon niet worden aangemaakt',
  category_edit_failure: 'De categorie kon niet worden bewerkt',
  category_delete_success: 'De categorie is succesvol verwijderd',
  category_delete_failure: 'De categorie kon niet worden verwijderd',
  timers: 'Timers',
  costs: 'Kosten',
  add_category: 'Nieuwe categorie toevoegen',
  add_category_description:
    'Vul de naam in om een nieuwe categorie aan te maken en toe te voegen',
  edit_category: 'Categorie bewerken',
  edit_category_description: 'Vul de naam in om de categorie te bewerken',
  no_category_action:
    "Druk op de '+' knop om uw eerste categorie toe te voegen.",
  confirm_delete_category:
    'Weet u zeker dat u deze categorie wilt verwijderen?',
  no_category_message:
    'Het lijkt erop dat u nog geen {{categoryName}} categorieën heeft.',
  acquisition_cost: 'Aanschafkosten',
  general_settings: 'Algemene instellingen',
  request_form_configuration: 'Configuratie aanvraagformulier',
  roles: 'Rollen',
  checklists: 'Checklists',
  field_configuration_description:
    'U kunt velden markeren als Optioneel, Verborgen of Verplicht',
  optional: 'Optioneel',
  required: 'Verplicht',
  hidden: 'Verborgen',
  creating_wo: 'Werkorder aanmaken',
  completing_wo: 'Werkorder afronden',
  role_edit_failure: 'De rol kon niet worden bewerkt',
  edit_role: 'Rol bewerken',
  edit_role_description: 'Vul de onderstaande velden in om de rol te bewerken',
  external_id: 'Externe ID',
  permissions: 'Rechten',
  create_role_description:
    'Deze rol kan alles wat een Administrator in Atlas kan, maar u kunt hieronder enkele belangrijke rechten aanpassen.',
  create_and_edit: 'Aanmaken/Bewerken',
  to_access: 'Toegang',
  role_delete_success: 'De rol is succesvol verwijderd',
  role_delete_failure: 'De rol kon niet worden verwijderd',
  confirm_delete_role: 'Weet u zeker dat u deze rol permanent wilt verwijderen',
  users: 'Gebruikers',
  paid: 'Betaald',
  free: 'Gratis',
  role_create_success: 'De rol is succesvol aangemaakt',
  role_create_failure: 'De rol kon niet worden aangemaakt',
  roles_management: 'Rollenbeheer',
  roles_number: '{{count}} rollen',
  create_role: 'Rol aanmaken',
  upgrade_role: 'Upgrade om rol aan te maken',
  add_role: 'Nieuwe rol toevoegen',
  add_role_description:
    'Vul de onderstaande velden in om een nieuwe rol aan te maken en toe te voegen',
  parts_and_sets: 'Onderdelen & Onderdelensets',
  upgrade_role_edit: 'Upgrade om rol te bewerken',
  delete_role: 'Rol verwijderen',
  upgrade_role_delete: 'Upgrade om rol te verwijderen',
  create: 'Aanmaken',
  pm_trigger: 'Preventief onderhoud trigger',
  auto_assign_wo: 'Werkorders automatisch toewijzen',
  auto_assign_wo_description:
    'Wijs nieuwe werkorders automatisch toe aan de persoon die ze aanmaakt',
  auto_assign_requests: 'Verzoeken automatisch toewijzen',
  auto_assign_requests_description:
    'Wijs nieuwe werkorders automatisch toe aan de persoon die het verzoek goedkeurt',
  disable_closed_wo_notification: 'Meldingen gesloten werkorders uitschakelen',
  disable_closed_wo_notification_description:
    'Schakel meldingen uit wanneer gesloten werkorders worden bijgewerkt',
  ask_feedback_wo_closed: 'Vraag om feedback wanneer werkorder is gesloten',
  ask_feedback_wo_closed_description:
    'Gebruikers worden gevraagd feedback te geven over het uitgevoerde werk',
  include_labor_in_total_cost: 'Arbeidskosten opnemen in de totale kosten',
  include_labor_in_total_cost_description:
    'Voeg arbeidskosten toe aan het totaal wanneer een gebruiker tijd registreert en een uurtarief is opgeslagen',
  enable_wo_updates_requesters: 'Werkorderupdates inschakelen voor Aanvragers',
  enable_wo_updates_requesters_description:
    'Gebruikers ontvangen updates voor de werkorders die zij hebben aangevraagd',
  language: 'Taal',
  date_format: 'Datumformaat',
  business_type: 'Bedrijfstype',
  general_asset_management: 'Algemeen assetbeheer',
  physical_asset_management: 'Fysiek assetbeheer',
  checklist_delete_success: 'De checklist is succesvol verwijderd',
  checklist_delete_failure: 'De checklist kon niet worden verwijderd',
  create_checklist: 'Checklist aanmaken',
  confirm_delete_checklist:
    'Weet u zeker dat u deze checklist wilt verwijderen?',
  upgrade_checklist: 'Upgrade alstublieft om checklists te gebruiken',
  upgrade_now: 'Nu upgraden',
  total: 'Totaal',
  sub_task_status: 'Status subtaak',
  text_field: 'Tekstveld',
  number_field: 'Nummer veld',
  inspection_check: 'Inspectiecontrole',
  multiple_choices: 'Meerdere keuzes',
  meter_reading: 'Meterstand',
  select_user: 'Selecteer gebruiker',
  PASS: 'Geslaagd',
  FLAG: 'Markeren',
  FAIL: 'Mislukt',
  enter_task_name: 'Voer een taaknaam in',
  see_details: 'Bekijk details',
  concerned_asset: 'Betrokken asset',
  me: 'Ik',
  remove_blank_tasks: 'Lege taken verwijderen',
  remove_blank_options: 'Lege opties verwijderen',
  preview: 'Voorbeeld',
  edit_checklist: 'Checklist bewerken',
  add_tasks: 'Taken toevoegen',
  use_a_checklist: 'Gebruik een checklist',
  select_checklist: 'Selecteer checklist',
  save_checklist: 'Checklist opslaan',
  assign_tasks_description:
    'Wijs aangepaste taken toe voor technici om in te vullen',
  select_date: 'Selecteer datum',
  task: 'Taak',
  checklist: 'Checklist',
  upgrade_analytics: 'Upgrade om Analytics te zien',
  grouped_by_category: 'Gegroepeerd op categorie',
  downtime_by_asset: 'Stilstand per asset',
  downtime_and_costs: 'Stilstand en kosten',
  downtime_and_costs_trends: 'Trends in stilstand en kosten',
  downtimes_trends: 'Trends in stilstanden',
  repair_time_by_asset: 'Reparatietijd per asset',
  consumed_parts_costs: 'Kosten verbruikte onderdelen',
  requests_by_priority: 'Verzoeken per prioriteit',
  requests_trends: 'Trends in verzoeken',
  time_spent: 'Besteedde tijd',
  grouped_by_completed_by: 'Gegroepeerd op voltooid door',
  grouped_by_assigned_to: 'Gegroepeerd op toegewezen aan',
  grouped_by_priority: 'Gegroepeerd op prioriteit',
  completion_comparison: 'Vergelijking van voltooiing',
  hours_worked: 'Gewerkte uren',
  work_remaining: 'Werk resterend',
  wo_status: 'Status werkorder',
  cost_trends: 'Kosten trends',
  cost_center: 'Kostenplaats',
  downtime_and_availability: 'Stilstand en beschikbaarheid',
  incomplete_wo: 'Onvoltooide werkorders',
  the_numbers: 'De cijfers',
  hours_and_cost_by_asset: 'Uren en kosten per asset',
  completion_comparison_description:
    'Vergelijking van verschillende typen voltooide werkorders.',
  wo_age_description:
    'Leeftijd van werkorder wordt gedefinieerd als het aantal dagen tussen het aanmaken van de werkorder (of werkverzoek) en vandaag.',
  rav_description:
    'Totale kosten als % van RAV is gelijk aan (kosten van werkorders op asset / aankoopprijs)*100. De industriestandaard is een streefwaarde van 3% voor deze metriek',
  downtime_and_availability_description:
    'Beschikbaarheid verwijst naar het percentage dat de assets operationeel waren sinds hun ingebruiknamedatum. Totale stilstanden verwijzen naar het aantal stilstandgebeurtenissen dat plaatsvond binnen de opgegeven datumbereik',
  total_cost_description:
    'Totale kosten omvatten arbeidskosten, bijkomende kosten en onderdelenkosten in een werkorder',
  compliant_wo_description:
    'Conforme werkorders worden gedefinieerd als werkorders die vóór de vervaldatum zijn voltooid. Cyclustijd verwijst naar het aantal dagen totdat een werkorder is voltooid.',
  hours_worked_description:
    'Deze uren komen overeen met werkorders die een vervaldatum hebben binnen het bereik dat is opgegeven in de filters.',
  work_remaining_description:
    'Deze grafiek toont het aantal onvoltooide werkorders die vervallen binnen het datumbereik dat is opgegeven in de filters. De geschatte uren komen overeen met die individuele werkorders.',
  total_downtime_in_hours: 'Totale stilstand (uren)',
  downtime_events: 'Stilstandgebeurtenissen',
  percent_downtime: '% Stilstand',
  meantime_between_failures_in_hours: 'Gemiddelde tijd tussen storingen (uren)',
  availability_percent: 'Beschikbaarheidspercentage',
  mean_time_to_repair_in_hours: 'Gemiddelde hersteltijd (uren)',
  average_age: 'Gemiddelde leeftijd',
  count: 'Aantal',
  average_cost: 'Gemiddelde kosten',
  compliant: 'Conform',
  average_cycle_time_in_days: 'Gemiddelde cyclustijd (dagen)',
  total_consumption_cost: 'Totale verbruikskosten',
  parts_consumed: 'Verbruikte onderdelen',
  total_cost_as_pct_rav: 'Totale kosten als percentage van RAV',
  approved_requests: 'Goedgekeurde aanvragen',
  pending_requests: 'In afwachting zijnde aanvragen',
  cancelled_requests: 'Geannuleerde aanvragen',
  average_cycle_time: 'Gemiddelde cyclustijd',
  compliance_rate: 'Nalevingspercentage',
  complete: 'Voltooid',
  reactive: 'Reactief',
  recurring: 'Terugkerend',
  part_costs: 'Onderdelenkosten',
  labor_costs: 'Arbeidskosten',
  total_time_spent_in_hours: 'Totale bestede tijd (uren)',
  estimated_hours: 'Geschatte uren',
  total_purchase_price: 'Totale aankoopprijs',
  you_have: 'U heeft',
  new_messages: 'nieuwe berichten',
  company: 'Bedrijf',
  change_cover: 'Omslag wijzigen',
  required_address: 'Het adresveld is verplicht',
  company_details: 'Bedrijfsgegevens',
  company_details_description:
    'Beheer informatie met betrekking tot uw bedrijf',
  learn_more: 'Meer informatie',
  profile: 'Profiel',
  email_notifications: 'E-mailmeldingen',
  email_updates_wo: 'E-mailupdates voor werkorders en berichten',
  email_updates_requests: 'E-mailupdates voor aangevraagde werkorders',
  po_emails: 'E-mails voor inkooporders',
  required_job_title: 'Het veld Functietitel is verplicht',
  required_old_password: 'Geef het huidige wachtwoord op.',
  invalid_password: 'Wachtwoord is te kort - moet minimaal 8 tekens bevatten.',
  required_new_password: 'Geen wachtwoord opgegeven.',
  passwords_must_match: 'Wachtwoorden moeten overeenkomen',
  password_change_success: 'Wachtwoord succesvol gewijzigd',
  wrong_password: 'Onjuist wachtwoord opgegeven',
  current_password: 'Huidig wachtwoord',
  new_password: 'Nieuw wachtwoord',
  confirm_password: 'Bevestig wachtwoord',
  personal_details: 'Persoonlijke gegevens',
  personal_details_description:
    'Beheer informatie met betrekking tot uw persoonlijke gegevens',
  change_password: 'Wachtwoord wijzigen',
  delete_account: 'Account verwijderen',
  delete_account_confirmation:
    'Weet u zeker dat u uw account wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
  account_deleted: 'Account succesvol verwijderd',
  account_delete_error: 'Fout bij het verwijderen van account',
  confirm_delete_account: 'Account verwijderen',
  notification_settings: 'Meldingsinstellingen',
  notification_settings_description:
    'Beheer details met betrekking tot uw meldingen',
  recent_activity: 'Recente activiteit',
  created: 'Aangemaakt',
  completed: 'Voltooid',
  my_account: 'Mijn account',
  my_company: 'Mijn bedrijf',
  you_are_using_plan:
    'U gebruikt momenteel het {{planName}}-plan. Het verloopt op {{expiration}}. Upgrade nu om toegang te krijgen tot meer functies.',
  upgrade_plan: 'Plan upgraden',
  plans: 'Plannen',
  monthly: 'Maandelijks',
  annually: 'Jaarlijks',
  subscription_change_success: 'Het abonnement is succesvol gewijzigd',
  invalid_credit_card: 'Creditcardnummer is ongeldig',
  required_credit_card: 'Het kaartveld is verplicht',
  invalid_expiration_month: 'Vervalmaand is ongeldig',
  required_expiration_month: 'De vervalmaand is verplicht',
  invalid_expiration_year: 'Vervaljaar is ongeldig',
  required_expiration_year: 'Het vervaljaar is verplicht',
  invalid_cvv: 'CVV is ongeldig',
  required_cvv: 'De CVV is verplicht',
  required_cardholder_name: 'De naam van kaarthouder is verplicht',
  card: 'Kaart',
  expiration_month: 'Vervalmaand',
  expiration_year: 'Vervaljaar',
  cardholder_name: 'Naam kaarthouder',
  seats: 'Stoelen',
  cost_per_seat: 'Kosten per stoel',
  your_payment_secure: 'Uw betalingsgegevens zijn versleuteld en veilig.',
  plan: 'Plan',
  current_plan: 'Huidig plan',
  number_users_who_will_use_grash:
    'Aantal gebruikers die Atlas zullen gebruiken',
  admin_role: 'Beheerder',
  technical_role: 'Technisch',
  limited_technical_role: 'Beperkt technisch',
  requester_role: 'Aanvrager',
  view_only_role: 'Alleen-lezen',
  how_will_you_be_billed: 'Hoe wilt u worden gefactureerd?',
  which_plan_fits_you: 'Welk plan past het beste bij u?',
  per_user_month: 'per gebruiker/maand',
  per_user_year: 'per gebruiker/jaar',
  you_will_be_charged: 'U wordt gefactureerd',
  proceed_to_payment: 'Ga door naar betaling',
  pay_only_for_roles:
    'Betaal alleen voor <strong>Beheerder</strong>, <strong>Technisch</strong> en <strong>Beperkt technisch</strong> gebruikers, en gebruik onbeperkt <strong>Aanvrager</strong>, <strong>Alleen-lezen</strong> gratis',
  checkout_our: 'Bekijk onze',
  pricing_page: 'Prijs pagina',
  for_more_details: 'voor meer details',
  users_count_display: '{{count}} gebruikers',
  monthly_adverb: 'maandelijks',
  yearly_adverb: 'jaarlijks',
  features: 'Functies',
  checkout: 'Afrekenen',
  checkout_description: 'Vul de onderstaande velden in',
  per_month: 'per maand',
  per_year: 'per jaar',
  recover_password_description:
    'Voer de e-mail in die voor registratie is gebruikt om uw wachtwoord te resetten.',
  send_me_new_password: 'Stuur mij een nieuw wachtwoord',
  want_to_sign_in_again: 'Wilt u opnieuw proberen in te loggen?',
  check_mails_for_instructions: 'Controleer uw e-mail voor verdere instructies',
  pdf_report: 'PDF-rapport',
  HIGH: 'Hoog',
  MEDIUM: 'Middel',
  LOW: 'Laag',
  NONE: 'Geen',
  import: 'Importeren',
  start_import_process: 'Start importproces',
  import_data: 'Gegevens importeren',
  set_header: 'Kop instellen',
  match_columns: 'Kolommen koppelen',
  review: 'Beoordelen',
  done: 'Klaar',
  no_match_yet: 'Nog geen koppeling',
  select: 'Selecteer...',
  matched_to_field: 'Gekoppeld aan {{field}}',
  next: 'Volgende',
  not_enough_rows: 'Niet genoeg rijen in het bestand',
  there_are_duplicates: 'Er zijn duplicaten: {{duplicates}}',
  assigned_by: 'Toegewezen door',
  percent_rows_have_value: '{{percent}}% van de rijen heeft waarde',
  match_at_least_column: 'Koppel ten minste één kolom',
  to_import: 'Importeren',
  required_match: '{{field}} koppeling is verplicht',
  archived: 'Gearchiveerd',
  import_wo_success:
    '{{created}} werkorders zijn aangemaakt en {{updated}} zijn bijgewerkt',
  to_export: 'Exporteren',
  filters: 'Filters',
  more_filters: 'Meer filters',
  customer: 'Aannemer',
  to: 'naar',
  dates: 'Data',
  start: 'Start',
  end: 'Einde',
  longitude: 'Lengtegraad',
  latitude: 'Breedtegraad',
  ALL: 'Alles',
  REACTIVE: 'Reactief',
  REPEATING: 'Preventief',
  import_location_success:
    '{{created}} locaties zijn aangemaakt en {{updated}} zijn bijgewerkt',
  import_part_success:
    '{{created}} onderdelen zijn aangemaakt en {{updated}} zijn bijgewerkt',
  import_meter_success:
    '{{created}} meters zijn aangemaakt en {{updated}} zijn bijgewerkt',
  import_asset_success:
    '{{created}} assets zijn aangemaakt en {{updated}} zijn bijgewerkt',
  wo_calendar: 'Werkorders Kalender',
  month: 'Maand',
  week: 'Week',
  day: 'Dag',
  agenda: 'Agenda',
  next_day: 'Volgende dag',
  previous_day: 'Vorige dag',
  today: 'Vandaag',
  to_filter: 'Filter',
  'noRows.asset.message':
    'Assets zijn middelen waarop uw bedrijf kan ingrijpen',
  'noRows.asset.action':
    "Druk op de '+' knop om een nieuwe Asset aan te maken.",
  reset_filters: 'Filters resetten',
  toggle_menu: 'Menu wisselen',
  no_results: 'Geen resultaten gevonden',
  an_error_occured: 'Er is een fout opgetreden.',
  density: 'Dichtheid',
  compact: 'Compact',
  standard: 'Standaard',
  comfortable: 'Comfortabel',
  columns: 'Kolommen',
  select_columns: 'Selecteer kolommen',
  show_filters: 'Toon filters',
  hide_filters: 'Verberg filters',
  search_placeholder: 'Zoeken…',
  search: 'Zoeken',
  clear: 'Wissen',
  download_as_csv: 'Download als CSV',
  print: 'Afdrukken',
  download_as_excel: 'Download als Excel',
  find_column: 'Zoek kolom',
  column_title: 'Kolomtitel',
  reorder_column: 'Kolom herschikken',
  show_all: 'Toon alles',
  hide_all: 'Verberg alles',
  add_filter: 'Filter toevoegen',
  logic_operator: 'Logische operator',
  operator: 'Operator',
  and: 'En',
  or: 'Of',
  filter_value: 'Filterwaarde',
  contains: 'bevat',
  equals: 'is gelijk aan',
  starts_with: 'begint met',
  ends_with: 'eindigt met',
  is: 'is',
  is_not: 'is niet',
  is_after: 'is na',
  is_on_or_after: 'is op of na',
  is_before: 'is voor',
  is_on_or_before: 'is op of voor',
  is_empty: 'is leeg',
  is_not_empty: 'is niet leeg',
  is_any_of: 'is een van',
  any: 'elke',
  true_text: 'waar',
  false_text: 'onwaar',
  menu: 'Menu',
  show_columns: 'Toon kolommen',
  hide: 'Verbergen',
  unsort: 'Sorteer niet',
  sort_by_ASC: 'Sorteer oplopend',
  sort_by_DESC: 'Sorteren op DESC',
  sort: 'Sorteren',
  total_rows: 'Totaal aantal rijen:',
  yes: 'Ja',
  no: 'Nee',
  more: 'Meer',
  to_group: 'Groeperen',
  see_children: 'kinderen bekijken',
  hide_children: 'kinderen verbergen',
  expand: 'Uitvouwen',
  collapse: 'Samenvouwen',
  detail_panel_toggle: 'Detailscherm wisselen',
  cancel_subscription: 'Abonnement annuleren',
  resume_subscription: 'Abonnement hervatten',
  confirm_cancel_subscription:
    'Weet u zeker dat u het abonnement wilt annuleren?',
  workflows: 'Workflows',
  create_workflow: 'Workflow aanmaken',
  if: 'Als',
  and_optional: 'En (optioneel)',
  then: 'Dan',
  workflow_description:
    'Maak aangepaste workflows net zo eenvoudig als Als, En, Dan. Bespaar tijd en wijs uw werkorders automatisch toe via workflows om Atlas aan te passen aan de manier waarop uw team werkt.Alle abonnementen kunnen tot 1 aangepaste workflow aanmaken. Voor extra workflows upgrade naar ons Business-abonnement',
  CREATE_PURCHASE_ORDER: 'Maak een inkooporder aan',
  PART_IS: 'Het onderdeel is',
  QUANTITY_INFERIOR: 'De hoeveelheid is minder dan',
  ASSIGN_VENDOR: 'Wijs de leverancier toe',
  ASSIGN_CATEGORY: 'Wijs de categorie toe',
  APPROVE: 'Goedkeuren',
  REJECT: 'Afwijzen',
  SEND_REMINDER_EMAIL: 'Herinneringsmail verzenden',
  VENDOR_IS: 'De leverancier is',
  CATEGORY_IS: 'De categorie is',
  STATUS_IS: 'De status is',
  DUE_DATE_BETWEEN: 'De vervaldatum ligt tussen',
  DUE_DATE_AFTER: 'De vervaldatum is na',
  ASSIGN_PRIORITY: 'Wijs de prioriteit toe',
  ASSIGN_ASSET: 'Wijs het activum toe',
  ASSIGN_LOCATION: 'Wijs de locatie toe',
  ASSIGN_USER: 'Wijs de gebruiker toe',
  ASSIGN_TEAM: 'Wijs het team toe',
  ADD_CHECKLIST: 'Checklist toevoegen',
  PRIORITY_IS: 'De prioriteit is',
  ASSET_IS: 'Het activum is',
  LOCATION_IS: 'De locatie is',
  USER_IS: 'De gebruiker is',
  TEAM_IS: 'Het team is',
  CREATED_AT_BETWEEN: 'Is aangemaakt tussen',
  TITLE_CONTAINS: 'De titel bevat',
  CREATE_REQUEST: 'Maak een verzoek aan',
  CREATE_WORK_ORDER: 'Maak een werkorder aan',
  SET_ASSET_STATUS: 'Stel activastatus in',
  NAME_IS: 'De naam is',
  NAME_CONTAINS: 'De naam bevat',
  VALUE_IS: 'De waarde is',
  VALUE_CONTAINS: 'De waarde bevat',
  NUMBER_VALUE_SUPERIOR: 'De waarde is groter dan',
  NUMBER_VALUE_INFERIOR: 'De waarde is kleiner dan',
  WORK_ORDER_CREATED: 'Er is een werkorder aangemaakt',
  WORK_ORDER_CLOSED: 'Er is een werkorder gesloten',
  WORK_ORDER_ARCHIVED: 'Er is een werkorder gearchiveerd',
  REQUEST_CREATED: 'Er is een verzoek aangemaakt',
  REQUEST_APPROVED: 'Er is een verzoek goedgekeurd',
  REQUEST_REJECTED: 'Er is een verzoek afgewezen',
  PURCHASE_ORDER_CREATED: 'Er is een inkooporder aangemaakt',
  PURCHASE_ORDER_UPDATED: 'Er is een inkooporder bijgewerkt',
  TASK_UPDATED: 'Er is een taak bijgewerkt',
  PART_UPDATED: 'Er is een onderdeel bijgewerkt',
  add_condition: 'Voorwaarde toevoegen',
  workflow_creation_success: 'Workflow succesvol aangemaakt',
  workflow_creation_failure: 'Workflow aanmaken is niet gelukt',
  action_value_missing: 'De actie waarde ontbreekt',
  condition_value_missing: 'Een voorwaarde waarde ontbreekt',
  workflow_edit_success: 'De workflow is succesvol bijgewerkt',
  workflow_edit_failure: 'De workflow kon niet worden bewerkt',
  workflow_delete_success: 'De workflow is succesvol verwijderd',
  workflow_delete_failure: 'De workflow kon niet worden verwijderd',
  confirm_delete_workflow: 'Weet u zeker dat u deze workflow wilt verwijderen',
  click_here: 'Klik hier',
  verify_email_title: 'E-mail verifiëren',
  verify_email_description:
    'Er is een verificatie-e-mail naar u verzonden. Controleer de spam als u deze niet in uw inbox ziet.',
  upgrade: 'Upgrade',
  downgrade: 'Downgrade',
  upgrade_description:
    'U heeft zojuist uw abonnementsplan geüpgraded. U moet de uitgeschakelde gebruikers inschakelen die mogelijk Atlas gebruiken. Dit kunt u slechts één keer doen voor het huidige abonnement. Kies zorgvuldig',
  enable_users: 'Gebruikers inschakelen',
  max_users_description: 'U kunt maximaal {{maxUsers}} gebruikers inschakelen',
  downgrade_description:
    'U heeft zojuist uw abonnementsplan gedowngraded. U moet enkele gebruikers uitschakelen om door te gaan. Dit kunt u slechts één keer doen voor het huidige abonnement. Kies zorgvuldig',
  disable_users: 'Gebruikers uitschakelen',
  min_users_description: 'U moet minimaal {{minUsers}} gebruikers uitschakelen',
  downgrade_description_no_owner:
    'Uw bedrijf heeft zojuist het abonnementsplan gedowngraded. De eigenaar van het bedrijf moet enkele gebruikers uitschakelen voordat u verder kunt',
  past_due: 'Verlopen',
  due_date_delay: 'Vertraging vervaldatum',
  due_date_delay_description: 'Vertraging vervaldatum in dagen',
  days_count: '{{days}} dagen',
  trigger_configuration: 'Triggerconfiguratie',
  WORK_ORDER_feature: 'Werkorders',
  REQUEST_feature: 'Werkverzoeken',
  PART_feature: 'Onderdelenbeheer',
  MOBILE_APP_feature: 'Mobiele app',
  WORK_ORDER_HISTORY_feature: 'Werkordergeschiedenis',
  PREVENTIVE_MAINTENANCE_feature: 'Preventief onderhoud',
  CHECKLIST_feature: 'Checklists',
  FILE_feature: 'Bestandsuploads',
  PURCHASE_ORDER_feature: 'Inkooporders',
  METER_feature: 'Meterstanden',
  REQUEST_CONFIGURATION_feature: 'Configuratie aanvraagformulier',
  ADDITIONAL_TIME_feature: 'Geavanceerde tijdregistratie',
  ADDITIONAL_COST_feature: 'Geavanceerde kostenregistratie',
  ANALYTICS_feature: 'Analyse & rapportage',
  REQUEST_PORTAL_feature: 'Aanvraagportaal',
  SIGNATURE_feature: 'Handtekeningen',
  ROLE_feature: 'Aangepaste rollen',
  WORKFLOW_feature: 'Workflow-automatisering',
  API_ACCESS_feature: 'API-toegang',
  WEBHOOK_feature: 'Webhooks',
  add_new_option: 'Nieuwe optie toevoegen',
  edit_company: 'Bedrijf bewerken',
  fill_fields_below: 'Vul de onderstaande velden in',
  IMPORT_CSV_feature: 'CSV-import',
  no_import_access:
    'Upgrade uw plan om te importeren vanuit CSV- en Excel-bestanden',
  register_here: 'Hier registreren',
  home: 'Home',
  user: 'Gebruiker',
  start_work_order: 'Werkorder starten',
  priority_label: '{{priority}} prioriteit',
  stop_work_order: 'Timer stoppen',
  required_files_on_completion:
    'Bestanden zijn vereist bij afronding van de werkorder',
  required_tasks_on_completion: 'Taken moeten voltooid zijn',
  required_labor_on_completion: 'U moet tijd registreren',
  required_part_on_completion:
    'Er is geen onderdeel gebruikt in deze werkorder',
  required_cost_on_completion:
    'Er zijn geen kosteninformatie verstrekt in deze werkorder',
  complete_work_order: 'Werkorder voltooien',
  no_parts: 'Geen onderdelen',
  edit_quantity: 'Aantal bewerken',
  remaining_tasks: '{{count}} resterende taken',
  complete_tasks_percent: '{{percent}}% voltooid',
  create_work_order: 'Werkorder aanmaken',
  select_customers: 'Selecteer klanten',
  select_vendors: 'Selecteer leveranciers',
  select_users: 'Selecteer gebruikers',
  select_teams: 'Selecteer teams',
  select_locations: 'Selecteer locaties',
  select_assets: 'Selecteer activa',
  select_categories: 'Selecteer categorieën',
  estimated_hours_in_text: '{{hours}} geschatte uren',
  create_meter: 'Meter aanmaken',
  create_location: 'Locatie aanmaken',
  create_request: 'Verzoek aanmaken',
  add_task: 'Taak toevoegen',
  select_task_type: 'Selecteer taaktype',
  assign_user: 'Gebruiker toewijzen',
  assign_asset: 'Activa toewijzen',
  add_options: 'Opties toevoegen',
  required_task_label: 'De taaklabel is verplicht',
  edit_work_order: 'Werkorder bewerken',
  confirmation: 'Bevestiging',
  LATE_WO: 'Te laat',
  TODAY_WO: 'Vandaag',
  HIGH_WO: 'Hoge prioriteit',
  no_element_match_criteria: 'Geen elementen voldoen aan dit criterium',
  required_part_name: 'Onderdelenaam is verplicht',
  only_assigned_to_me: 'Alleen aan mij toegewezen',
  complete_work_orders: 'Voltooide werkorders',
  this_week: 'Deze week',
  all_time: 'Alle tijden',
  compliant_work_orders: 'Conforme werkorders',
  stats: 'Statistieken',
  vendors_and_customers: 'Leveranciers & Aannemers',
  no_notification_message:
    'Belangrijke updates verschijnen hier om u te helpen de voortgang van uw werk te volgen',
  no_notification: 'Geen melding',
  view_children: 'Bekijk onderliggende items',
  loading: 'Laden',
  please_wait: 'Even geduld aub...',
  add_file: 'Bestand toevoegen',
  asset_update_failure: 'Het activum kon niet worden bewerkt',
  no_wo_linked_location: 'Geen werkorder op deze locatie',
  confirm_delete_file_location:
    'Weet u zeker dat u dit bestand van deze locatie wilt verwijderen?',
  confirm_delete_file_part:
    'Weet u zeker dat u dit bestand van dit onderdeel wilt verwijderen?',
  no_wo_linked_part: 'Geen werkorder gekoppeld aan dit onderdeel',
  edit_customer: 'Aannemer bewerken',
  edit_vendor: 'Leverancier bewerken',
  reading_history: 'Leesgeschiedenis',
  user_invite_success: 'De gebruiker is uitgenodigd',
  user_invite_failure: 'De gebruiker kon niet worden uitgenodigd',
  create_child_asset: 'Maak een onderliggend activum aan',
  not_enough_part: 'Er is niet genoeg van dit onderdeel',
  update_profile: 'Profiel bijwerken',
  confirm_logout: 'Weet u zeker dat u wilt uitloggen?',
  report: 'Rapport',
  end_cannot_be_ulterior_to_start:
    'Einddatum mag niet later zijn dan startdatum',
  storage_permission_needed_description:
    'U moet opslagtoestemming geven om het bestand te downloaden',
  permission_denied: 'Toestemming geweigerd!',
  to_scan: 'Scannen',
  nfc_tag: 'NFC-tag',
  scanning: 'Bezig met scannen',
  error: 'Fout',
  tag_not_found: 'Tag niet gevonden',
  'no nfc support': 'Geen NFC-ondersteuning',
  remaining_parts: '{{quantity}} resterend',
  team_members_count: '{{count}} leden',
  no_asset_found_nfc:
    'Geen activum gevonden met deze NFC-tag. Wilt u het aanmaken?',
  no_access_to_camera: 'Geen toegang tot camera',
  no_asset_found_barcode:
    'Geen activum gevonden met deze streepjescode. Wilt u het aanmaken?',
  remove_blank_meter_tasks: 'Selecteer een meter',
  no_notification_permission: 'Geen meldingsmachtiging',
  no_notification_permission_description:
    'Ga naar instellingen en activeer handmatig de meldingsmachtiging',
  allow: 'Toestaan',
  failed_push_notification: 'Kon geen push-token verkrijgen voor pushmelding!',
  no_internet_connection: 'Geen internetverbinding',
  success: 'Succes',
  info: 'Info',
  switch_account: 'Account wisselen',
  switch_to_super_user: 'Overschakelen naar superbeheerder',
  switch_account_description: 'Kies een account om door te gaan',
  manufacturer: 'Fabrikant',
  power: 'Vermogen',
  library: 'Bibliotheek',
  camera: 'Camera',
  CANCELLED: 'Geweigerd',
  max_file_size_error:
    'De bestandsgrootte mag niet groter zijn dan {{size}} MB',
  assignedToUser: 'Mijn werk',
  mark_all_as_seen: 'Alles als gezien markeren',
  estimated_start_date: 'Verwachte startdatum',
  audio_description: 'Audiobeschrijving',
  start_recording: 'Opname starten',
  stop_recording: 'Opname stoppen',
  OPERATIONAL: 'Operationeel',
  DOWN: 'Uitgevallen',
  MODERNIZATION: 'Modernisering',
  STANDBY: 'Stand-by',
  INSPECTION_SCHEDULED: 'Inspectie gepland',
  COMMISSIONING: 'Indienststelling',
  EMERGENCY_SHUTDOWN: 'Noodstop',
  select_asset_status: 'Selecteer activastatus',
  asset_status: 'Activastatus',
  custom_server: 'Aangepaste server',
  custom_server_title: 'Instellingen aangepaste server',
  custom_server_description:
    'Configureer een aangepaste API-server URL. Wijzig deze instelling alleen als u uw eigen server gebruikt.',
  server_url: 'Server URL',
  required_url: 'Server URL is verplicht',
  server_url_saved: 'Server URL succesvol opgeslagen',
  error_saving_url: 'Fout opgetreden bij het opslaan van de Server URL',
  server_url_reset: 'Server URL teruggezet naar standaard',
  reset_to_default: 'Terugzetten naar standaard',
  list: 'Lijst',
  back_to: 'Terug naar',
  top_level: 'Hoofdniveau',
  no_results_found: 'Geen resultaten gevonden',
  no_sub_assets: 'Geen sub-assets',
  no_assets_available: 'Geen assets beschikbaar',
  csv_separator: 'CSV scheidingsteken',
  open_source_cmms: 'Open-source CMMS',
  'main.title': 'Gratis open-source CMMS (onderhoudsbeheersoftware) – ',
  'home.h1':
    'Gratis en open-source CMMS dat u zelf kunt hosten of in de cloud kunt gebruiken',
  'home.h2': 'Krachtig onderhoud tegen lage kosten',
  'home.h3':
    'Stop met vertrouwen op spreadsheets en whiteboards. {{brandName}} helpt onderhoudsteams bij het plannen van interventies, het volgen van apparatuur en het naleven van de voorschriften. Host op uw eigen server of start direct in de cloud.',
  talk_to_sales: 'Praat met verkoop',
  'pricing.choose_plan_and_get_started':
    'Kies je abonnement en ga aan de slag.',
  'pricing.slogan_effective_maintenance':
    'Onze software biedt onderhouds- en betrouwbaarheidsteams de tools die ze nodig hebben om de bedrijfsvoering efficiënt en effectief te laten verlopen.',
  'pricing.compare_plans_and_pricing': 'Vergelijk abonnementen en prijzen',
  'pricing.see_which_plan_is_right_for_you':
    'Ontdek welk abonnement het beste bij u past.',
  'pricing.select_two_plans_to_compare':
    'Selecteer 2 abonnementen om te vergelijken.',
  'pricing.select_three_plans_to_compare':
    'Selecteer 3 abonnementen om te vergelijken.',
  'pricing.month_per_user': 'maand per gebruiker',
  'pricing.year_per_user': 'jaar per gebruiker',
  'pricing.plan_basic_name': 'Basis',
  'pricing.plan_basic_description':
    "Teams die activa willen volgen en fundamentele preventieve onderhoudsschema's met bijbehorende procedures willen opstellen.",
  'pricing.feature_unlimited_work_orders': 'Onbeperkt aantal werkorders',
  'pricing.feature_custom_tasks': 'Aangepaste taken',
  'pricing.feature_unlimited_request_user_licenses':
    'Onbeperkt aantal gebruikerslicenties aanvragen',
  'pricing.plan_starter_name': 'Starter',
  'pricing.plan_starter_description':
    'Teams die efficiënt en sterk preventief onderhoud willen opzetten door inzicht te krijgen in de machinestatus en de personeelsbezetting.',
  'pricing.feature_everything_in_basic_plus': 'Alles in Basic plus:',
  'pricing.feature_preventive_maintenance_recurring_work_orders':
    'Preventief onderhoud/Terugkerende werkorders',
  'pricing.feature_custom_checklists': 'Aangepaste checklists',
  'pricing.feature_inventory_management_costing':
    'Voorraadbeheer/Kostenberekening',
  'pricing.feature_time_and_manpower_tracking':
    'Tijd- en personeelsregistratie',
  'pricing.feature_thirty_day_analytics_reporting':
    'Analyse en rapportage over 30 dagen',
  'pricing.plan_professional_name': 'Professioneel',
  'pricing.plan_professional_description':
    'Afdelingen die inzichten en analyses moeten benutten om de groei en productiviteit van het onderhoud verder te stimuleren.',
  'pricing.feature_everything_in_starter_plus': 'Alles in Starter plus:',
  'pricing.feature_multiple_inventory_lines': 'Meerdere voorraadregels',
  'pricing.feature_customizable_request_portal': 'Aanpasbaar aanvraagportaal',
  'pricing.feature_mobile_offline_mode': 'Mobiele offline modus',
  'pricing.feature_advanced_analytics_reporting':
    'Geavanceerde analyses en rapportage',
  'pricing.plan_business_name': 'Bedrijf',
  'pricing.plan_business_description':
    'Organisaties die klaar zijn om onderhouds- en operationele gegevens vast te leggen voor het beheer van meerdere locaties en systeemaanpassingen.',
  'pricing.feature_everything_in_professional_plus':
    'Alles in Professional plus:',
  'pricing.feature_purchase_order_management': 'Inkooporderbeheer',
  'pricing.feature_multi_site_module_support':
    'Moduleondersteuning voor meerdere locaties',
  'pricing.feature_custom_work_order_statuses':
    'Status van aangepaste werkorders',
  'pricing.feature_custom_integrations_support':
    'Ondersteuning voor maatwerkintegraties',
  'pricing.feature_work_order_management': 'Werkorderbeheer',
  'pricing.feature_recurring_work_orders': 'Terugkerende werkorders',
  'pricing.feature_custom_categories': 'Aangepaste categorieën',
  'pricing.feature_data_importing': 'Gegevens importeren',
  'pricing.feature_time_and_cost_tracking': 'Tijd- en kostenregistratie',
  'pricing.feature_work_order_configuration': 'Werkorderconfiguratie',
  'pricing.feature_internal_requests': 'Interne verzoeken',
  'pricing.feature_external_request_portal': 'Extern aanvraagportaal',
  'pricing.category_locations_assets_parts': 'Locaties, activa en onderdelen',
  'pricing.feature_location_management': 'Locatiebeheer',
  'pricing.feature_barcode_scanning': 'Barcode scannen',
  'pricing.feature_inventory_management': 'Voorraadbeheer',
  'pricing.feature_custom_asset_statuses': 'Aangepaste activastatussen',
  'pricing.feature_asset_downtime_tracking':
    'Registratie van uitval van activa',
  'pricing.feature_asset_depreciation_tracking':
    'Het bijhouden van de afschrijving van activa',
  'pricing.feature_asset_warranty_tracking': 'Garantiebewaking van activa',
  'pricing.feature_purchase_orders_management': 'Inkooporders',
  'pricing.feature_asset_check_in_out': 'In- en uitchecken van activa',
  'pricing.category_mobile_offline': 'Mobiel offline',
  'pricing.feature_work_order_availability': 'Beschikbaarheid van werkorders',
  'pricing.feature_updating_status': 'Status bijwerken',
  'pricing.feature_updating_tasks': 'Taken bijwerken',
  'pricing.feature_work_order_drafts': 'Werkorderconcepten',
  'pricing.feature_full_drill_down_reporting_history':
    'Gedetailleerde rapportage en geschiedenis',
  'pricing.period_thirty_days': '30 dagen',
  'pricing.period_full': 'Vol',
  'pricing.feature_pdf_csv_exporting': 'PDF- en CSV-export',
  'pricing.feature_itemized_time_reporting': 'Gedetailleerde urenregistratie',
  'pricing.feature_user_login_reports': 'Gebruikersaanmeldingsrapporten',
  'pricing.feature_parts_consumption_reports':
    'Rapporten over onderdelenverbruik',
  'pricing.feature_asset_downtime_reports': 'Rapporten over uitval van activa',
  'pricing.feature_equipment_reliability_reports':
    'Rapporten over de betrouwbaarheid van apparatuur',
  'pricing.feature_multi_site_modules': 'Modules voor meerdere locaties',
  'pricing.category_integrations': 'Integraties',
  'pricing.feature_business_integrations':
    'Bedrijfsintegraties (SAP/Oracle/Causal AI...)',
  'pricing.feature_custom_integrations': 'Maatwerkintegraties',
  'pricing.feature_unlimited_view_only_users':
    'Onbeperkt aantal gebruikers met alleen-leestoegang',
  'pricing.feature_unlimited_requesters': 'Onbeperkt aantal aanvragers',
  'pricing.feature_unlimited_vendors': 'Onbeperkt aantal leveranciers',
  'pricing.feature_unlimited_customers': 'Onbeperkt aantal klanten',
  'pricing.category_support': 'Steun',
  'pricing.feature_daily_email_digest': 'Dagelijkse e-mailsamenvatting',
  'pricing.feature_articles': 'Artikelen',
  'pricing.feature_training_webinars': 'Trainingswebinars',
  'pricing.feature_community_support_discord':
    'Communityondersteuning (Discord)',
  'pricing.feature_email_support': 'E-mailondersteuning',
  'pricing.feature_chat_phone_support': 'Chat-/telefoonondersteuning',
  'pricing.feature_priority_support': 'Prioriteitsondersteuning',
  'pricing.feature_implementation_training': 'Implementatie en training',
  'pricing.feature_dedicated_account_manager': 'Toegewijde accountmanager',
  'pricing.category_customization': 'Aanpassing',
  'pricing.feature_custom_development': 'Maatwerkontwikkeling',
  'pricing.sh_plan_basic_name': 'Basis',
  'pricing.sh_plan_basic_description':
    'Voor kleine teams die volledige datasoevereiniteit en basisonderhoudsregistratie op hun eigen infrastructuur nodig hebben.',
  'pricing.sh_feature_core_work_order_management': 'Kernwerkorderbeheer',
  'pricing.sh_feature_asset_inventory_tracking': 'Activa- en voorraadbeheer',
  'pricing.sh_feature_local_data_storage': 'Lokale gegevensopslag',
  'pricing.sh_plan_professional_name': 'Professioneel',
  'pricing.sh_plan_professional_description':
    'Ideaal voor het kweken van planten die geavanceerde checklists, workflows en een diepere systeemintegratie vereisen.',
  'pricing.sh_feature_everything_in_basic_plus': 'Alles in Basic plus:',
  'pricing.sh_feature_unlimited_assets_checklists':
    'Onbeperkt aantal items/checklists',
  'pricing.sh_feature_nfc_barcode_scanning': 'NFC- en barcodescanning',
  'pricing.sh_feature_email_support': 'E-mailondersteuning',
  'pricing.sh_plan_business_name': 'Bedrijf',
  'pricing.sh_plan_business_description':
    'Grootschalige operaties die beheer van meerdere instanties, aangepaste branding en eersteklas beveiliging vereisen.',
  'pricing.sh_feature_everything_in_professional_plus':
    'Alles in Professional plus:',
  'pricing.sh_feature_multi_instance_management':
    'Beheer van meerdere instanties',
  'pricing.sh_feature_custom_user_roles': 'Aangepaste gebruikersrollen',
  'pricing.sh_feature_priority_implementation_support':
    'Prioritaire implementatieondersteuning',
  'pricing.faq_free_users_q':
    'Welke soorten gebruikers worden beschouwd als gratis gebruikers?',
  'pricing.faq_free_users_a1':
    'Er zijn drie gebruikerstypen die geen betaalde licentie nodig hebben:',
  'pricing.faq_view_only_users_title': 'Gebruikers met alleen-leestoegang',
  'pricing.faq_view_only_users_description':
    'Deze gebruikers zijn doorgaans supervisors die slechts af en toe inloggen om een overzicht van de onderhoudsactiviteiten te bekijken. Ze kunnen ook werkverzoeken indienen en rapporten genereren.',
  'pricing.faq_requester_users_title': 'Aanvragers Gebruikers',
  'pricing.faq_requester_users_description':
    'Deze gebruikers kunnen alleen werkverzoeken indienen en de status van die verzoeken bekijken. Ze kunnen geen werkorders, activa, onderdelen of andere gegevens die in het CMMS zijn opgeslagen, inzien.',
  'pricing.faq_third_party_users_title': 'Gebruikers van derden',
  'pricing.faq_third_party_users_description':
    'Deze gebruikers zijn doorgaans leveranciers en aannemers. Ze kunnen niet rechtstreeks inloggen op het systeem. Ze kunnen alleen updates indienen voor een specifieke werkorder waaraan ze zijn gekoppeld via een openbare link.',
  'pricing.faq_paid_users_q':
    'Welke soorten gebruikers worden beschouwd als betalende gebruikers?',
  'pricing.faq_paid_users_a1':
    'Er zijn drie gebruikerstypen waarvoor een betaalde licentie vereist is:',
  'pricing.faq_admin_users_title': 'Beheerders',
  'pricing.faq_admin_users_description':
    'Deze gebruikers kunnen anderen aan het account toevoegen, werkverzoeken accepteren of afwijzen en details van werkorders bewerken. Zij zijn de gebruikers die het account beheren. Je kunt meerdere beheerders per account hebben.',
  'pricing.faq_technical_users_title': 'Technische gebruikers',
  'pricing.faq_technical_users_description':
    "Deze gebruikers zijn doorgaans technici die werkorders in het veld afronden. Ze kunnen werkorders die ze zelf hebben aangemaakt bewerken, maar niet die van anderen. Ze kunnen foto's en statusupdates aan werkorders toevoegen en nieuwe werkorders aanmaken.",
  'pricing.faq_limited_technical_users_title':
    'Beperkt aantal technische gebruikers',
  'pricing.faq_limited_technical_users_description':
    'Deze gebruikers hebben dezelfde rechten als de technische gebruiker. Het enige verschil is dat ze alleen de aan hen toegewezen werkorders kunnen zien, en niet die van andere technische gebruikers op het account.',
  'pricing.faq_change_plans_q': 'Kan ik mijn plannen later nog wijzigen?',
  'pricing.faq_change_plans_a':
    'Ja, u kunt uw abonnement op elk moment upgraden of downgraden. Wijzigingen gaan in aan het begin van uw volgende factureringscyclus.',
  'pricing.faq_free_trial_q': 'Is er een gratis proefperiode?',
  'pricing.faq_free_trial_a':
    'Ja, we bieden een gratis proefperiode van 15 dagen voor het Business-abonnement, zodat u alle functies kunt uitproberen voordat u een beslissing neemt.',
  'pricing.faq_non_profit_discounts_q':
    'Bieden jullie kortingen aan non-profitorganisaties?',
  'pricing.faq_non_profit_discounts_a':
    'Ja, we bieden speciale tarieven voor non-profitorganisaties. Neem contact op met ons verkoopteam voor meer informatie.',
  'pricing.faq_payment_methods_q': 'Welke betaalmethoden accepteert u?',
  'pricing.faq_payment_methods_a':
    'Wij accepteren alle gangbare creditcards, bankoverschrijvingen en PayPal. Voor zakelijke abonnementen kunnen wij ook de facturering verzorgen.',
  'pricing.faq_cancel_subscription_q': 'Kan ik mijn abonnement opzeggen?',
  'pricing.faq_cancel_subscription_a':
    'Ja, u kunt uw abonnement op elk moment opzeggen. U behoudt toegang tot het einde van uw huidige factureringsperiode.',
  'pricing.faq_data_secure_q': 'Zijn mijn gegevens veilig?',
  'pricing.faq_data_secure_a':
    'Ja, we nemen gegevensbeveiliging zeer serieus. Alle gegevens worden zowel tijdens de overdracht als in rust versleuteld en we voeren regelmatig beveiligingsaudits uit.',
  'pricing.faq_title': 'Veelgestelde vragen',
  'pricing.annually_save_two_months': 'Jaarlijks (Bespaar 2 maanden)',
  'pricing.most_popular': 'Meest populair',
  'pricing.get_your_license': 'Haal je rijbewijs',
  get_started: 'Aan de slag',
  workflow_automation: 'Werkstroomautomatisering',
  push_notifications: 'Pushmeldingen',
  cloud: 'Wolk',
  self_hosted: 'Zelf gehost',
  full: 'Vol',
  pricing: 'Prijzen',
  industries: 'Sectoren',
  work_order_management: 'Werkorderbeheer',
  inventory_management: 'Voorraadbeheer',
  analytics_and_reporting: 'Analyse en rapportage',
  manufacturing: 'Productie',
  facility_management: 'Facilitair management',
  food_and_beverage: 'Voeding en dranken',
  healthcare: 'Gezondheidszorg',
  energy_and_utilities: 'Energie en nutsbedrijven',
  education: 'Onderwijs',
  hospitality: 'Gastvrijheid',
  construction: 'Bouw'
};
export default locale;
